import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import OverlayFunction from './page/OverlayFunction';

export default function OverlayFunctionFeature() {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <Route exact path={`${path}/`}>
          <OverlayFunction />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
}
